import { PreloadingStrategy, Route,RouterModule,PreloadAllModules, } from '@angular/router';
import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';


@Injectable()

export class AppCustomPreloader implements PreloadingStrategy {
  preload(route: Route, load: Function): Observable<any> {
    return route.data && route.data.preload ? load() : of(null);
  }
}